import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  pdf,
} from '@react-pdf/renderer';
import { useEffect, useState } from 'react';
import Html from 'react-pdf-html';
import { useLazyGetSixMonthlyReportDataQuery } from 'src/rtk/features/logbookMonitoringReport/logbookMonitoringReportApi';
import loader from '../../assets/images/loader.gif';
import moment from 'moment';
import { useAppSelector } from 'src/rtk/app/hook';
import { config } from 'src/config';

interface Props {
  userInfo: any;
  setReportId: any;
}
// Create styles
const styles = StyleSheet.create({
  page: {
    margin: 20,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0,
  },
  nextLine: {
    marginTop: -20,
    textAlign: 'center',
    fontSize: '10px',
  },
});

// Create Document Component
// const MyDocument = () => (
//   <Document>
//     <Page size="A4" style={styles.page}>
//       <View style={styles.section}>
//         <Text>Section #1</Text>
//       </View>
//       <View style={styles.section}>
//         <Text>Section #2</Text>
//       </View>
//     </Page>
//   </Document>
// );

export const SixMonthlyReportPDF = (props: Props) => {
  const { userInfo, setReportId } = props;
  const [getSixMonthlyReportData, { data: list, isSuccess, isLoading }] =
    useLazyGetSixMonthlyReportDataQuery();

  useEffect(() => {
    getSixMonthlyReportData({
      userId: userInfo?.profile_info?.user_id,
      sessionId: userInfo?.id
    });
  }, []);


    const token = useAppSelector((state) => state.auth.token);
    const [traineeSignatureImageBase64, setTraineeSignatureImageBase64] = useState('');
    const [supervisorSignatureImageBase64, setSupervisorSignatureImageBase64] = useState('');

  
  
    const fetchImageBase64 = async (filepath: string) => {
      const res = await fetch(`${config.API_URL}/v1/get-image?filepath=${filepath}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`, // if needed
          'Accept': 'image/*',                    // optional
        },
      });
  
      const blob = await res.blob();
      const reader = new FileReader();
  
      return await new Promise<string>((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    };
  
  
    useEffect(() => {
      if (userInfo?.profile_info?.personal_info?.signature) {
        fetchImageBase64(userInfo?.profile_info?.personal_info?.signature.replace(/^storage\//, "")).then((base64) => {
          setTraineeSignatureImageBase64(base64);
        });
      }
      if (userInfo?.supervisor?.signature) {
        fetchImageBase64(userInfo?.supervisor?.signature.replace(/^storage\//, "")).then((base64) => {
          setSupervisorSignatureImageBase64(base64);
        });
      }
    }, [userInfo?.supervisor?.signature, userInfo?.profile_info?.personal_info?.signature]);

  const data: any = Array.isArray(list?.data) ? list?.data : [];

  console.log(data);
  let pdfUrl = '';

  const findParticulars = (particulars: string) => {
    return data.find((item: any) => item.particulars === particulars);
  }
  
  const html = `  
  <html>    
    <body>
        <style>                    
        .print-container{
          padding: 0 15px;
        }

        .wide-column {
          width: 500px;
          background-color: powderblue;
        }

        table {
          margin: 3px 0px;
          padding: 0px;
          border: 1px solid black;
          font-size: 12px;
        }
        p{
          font-size: 14px;
          margin: 10px 0px;

        }
        table > tbody> tr > *{
          padding: 4.5px
        }

        table th {
          text-align: center;    
        }
        
        table td {
                       
        }

        .bgColor {
          background-color: powderblue;
        }
        b {
          font-family: 'Times-Bold'; 
        }

        .signature-box {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 10px;
          padding: 0 10px;
        }

        .assessment-section {
          padding: 0 10px;
        }

       
      </style>

      <div class="print-container"> 
        <table>
          <tbody>
            <tr>
              <td><b>Name:</b></td>
              <td>${userInfo?.profile_info?.personal_info?.full_name ?? ''}</td>
              <td><b>PRN Number:</b></td>
              <td>${userInfo?.profile_info?.bmdc_registration_no ?? ''}</td>
            </tr>
            <tr>
              <td><b>Place of Training:</b></td>
              <td>${
                userInfo?.supervisor?.institute_name ?? ''
              }</td>
              <td><b>Name of Supervisor:</b></td>
              <td>${
                userInfo?.supervisor?.name ?? ''
              }</td>
            </tr>
            <tr>
              <td><b>Report For Duration of:</b>
                ${moment(userInfo?.session_start_date).format('DD/MMM/YYYY') ?? ''} to${' '}  ${moment(userInfo?.session_end_date).format('DD/MMM/YYYY') ?? ''}
              </td>
            </tr>
          </tbody>
        </table>
        <p>1.Number of Patient Managed: ${findParticulars('Patient Management')?.total ?? ''}</p>
        <table>
          <thead> 
            <tr style="background-color: powderblue;">
              <th>Inpatient</th>
              <th>Outpatient</th>
              <th>Emergency</th>
            </tr>
          </thead>
          <tbody>
            <tr>
            ${findParticulars('Patient Management')?.entry_setup_master_for_log ?
              findParticulars('Patient Management')?.entry_setup_master_for_log
              ?.map(
                (item: any) =>
                  `
               <td>${item?.total ?? ''}</td>
              `,
              )
              .join('') : ''}
            </tr>
          </tbody>
          </table> 
          <p>2. Number of History Writing : ${findParticulars('Patient Management')?.history_count ?? ''}</p>
          <p>3. Number of procedures done: </p>
        <table>
          <thead> 
            <tr style="background-color: powderblue;">
              <th style="width: 70%">Name of the procedure</th>
              <th>Number</th>
            </tr>
          </thead>
          <tbody>
            ${findParticulars('Procedural and Interpretative Skills')?.entry_setup_master_for_log ?
              findParticulars('Procedural and Interpretative Skills')?.entry_setup_master_for_log
              ?.map(
                (item: any) =>
                  `<tr>
                <td>${item?.particulars ?? ''}</td>
                <td>${item?.total ?? ''}</td>
               </tr>
              `,
              )
              .join('') : ''}
              <tr>
                <td><b>Total</b></td>
                <td>
                  ${findParticulars('Procedural and Interpretative Skills')?.entry_setup_master_for_log ?
                    findParticulars('Procedural and Interpretative Skills')?.entry_setup_master_for_log?.reduce(
                    (total: any, item: any) => {
                      return total + item.total;
                    },
                    0,
                  ) : ''}
                </td>
              </tr>
          </tbody>
        </table> 
        <p>4. Academic activities: </p>
        <table>
          <thead> 
            <tr style="background-color: powderblue;">
              <th style="width: 90;">Category</th>
              <th>Number</th>
              <th>Presented</th>
              <th>Attended</th>
            </tr>
          </thead>
          <tbody>
            ${findParticulars('Academic Activity')?.entry_setup_master_for_log ? 
              findParticulars('Academic Activity')?.entry_setup_master_for_log
              ?.map(
                (item: any) =>
                  `<tr>
                <td>${item?.particulars ?? ''}</td>
                <td>${item?.total ?? ''}</td>
                <td>0</td>
                <td>${item?.total ?? ''}</td>
               </tr>
              `,
              )
              .join('') : ''}
          </tbody>
        </table>
        <div class="assessment-section">
          <p>5. Formative assessment: </p>
          <span style="font-size: 12;">
            Results of mini-CEX ____________________________<br/>
            Results of CBD         _____________________________<br/>
            General comment on direct observation – during bed-side case discussion, patient management, dealing with patients, dealing with nurses and doctor colleague, attitude:  Very good.
            [Excellent/Very good/Good/Satisfactory/ Unsatisfactory]
          
            <br/>
            Status of dissertation work: __________________________________________________________________________________
          </span>
        </div>
        <div class="signature-box">
          <div>
            <img src="${traineeSignatureImageBase64}" style="width: 120px; height: 30px; margin-bottom: 0px;" />
            <div>---------------------</div>
            <span style="font-size: 12;">Signature of the Trainee</span>
          </div>
          <div>
            <img src="${supervisorSignatureImageBase64}" style="width: 120px; height: 30px; margin-bottom: 0px;" />
            <div>--------------------</div>
            <span style="font-size: 12;">Signature of the Supervisor</span>
          </div>
        </div>
      </div>      
    </body>
  </html>
`;

  // const MyDocument = (
  //   <Document>
  //     <Page size="A4" style={styles.page}>
  //       <View style={styles.section}>
  //         <Text>Section #1</Text>
  //       </View>
  //       <View style={styles.section}>
  //         <Text>Section #2</Text>
  //       </View>
  //     </Page>
  //   </Document>
  // );

  const MyDocument = (
    <Document>
      <Page size="A4">
        <View style={styles.row}>
          <Image
            src="/images/apple-icon-180x180.png"
            style={{
              width: '40px',
              marginTop: '20px',
              marginBottom: '0px',
              marginLeft: '10px',
            }}
          />
          <Text
            style={{
              textAlign: 'center',
              fontFamily: 'Times-Bold',
              fontSize: '14px',
              margin: '20px',
              marginBottom: '0px',
            }}
          >
            BANGLADESH COLLEGE OF PHYSICIANS AND SURGEONS (BCPS)
          </Text>
        </View>
        <Text style={styles.nextLine}>
          67, Shaheed Tajuddin Ahmed Sarani, Mohakhali, Dhaka-1212
        </Text>
        <Text
          style={{
            textAlign: 'center',
            fontFamily: 'Helvetica-Bold',
            fontSize: '14px',
            margin: '15px',
          }}
        >
          Six Monthly Training Report
        </Text>
        <Text
          style={{
            textAlign: 'center',
            fontFamily: 'Helvetica',
            fontSize: '10px',
          }}
        >
          (Competency based Residential Training for Fellowship)
        </Text>
        <Html>{html}</Html>
      </Page>
    </Document>
  );

  useEffect(() => {
    if (isSuccess && traineeSignatureImageBase64 && supervisorSignatureImageBase64) {
      const pdfData = pdf(MyDocument).toBlob();
      pdfData.then((pdfData) => {
        const pdfContent = new Blob([pdfData], { type: 'application/pdf' });
        const url = URL.createObjectURL(pdfContent);
        setReportId('');
        window.open(url, '_blank');
      });
    }
  }, [isSuccess, traineeSignatureImageBase64, supervisorSignatureImageBase64]);
  

  return (
    <div>
      {isLoading ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null}
    </div>
  );
};
